/**
 * Cardible's public social profiles.
 *
 * Used by the footer, the About page, and the Organization JSON-LD `sameAs`
 * on the homepage — search engines treat sameAs as the link between this site
 * and the accounts that verify it, so a dead URL here is worse than none.
 *
 * Verified live on 2026-09-07. Facebook and Instagram are the only two
 * accounts that exist; there is no LinkedIn, X or TikTok presence yet.
 *
 * The Facebook page has no vanity username, so its canonical URL is the
 * numeric profile.php form. Claiming @cardible.io on Facebook would make this
 * a cleaner link — update it here if that happens.
 */
export const SOCIAL_LINKS = [
  { name: "Facebook", url: "https://www.facebook.com/profile.php?id=61576237541554" },
  { name: "Instagram", url: "https://www.instagram.com/cardible.io/" },
];

/**
 * Jay's own professional profiles (site audit D3.3). Shown beside the Cardible
 * accounts under his name on /about, and emitted as `founder.sameAs` in the
 * Organization JSON-LD. A business buyer on /for-business checks the
 * founder's LinkedIn before joining a pilot.
 *
 * EMPTY ON PURPOSE — no public profile could be matched to Jay with
 * confidence on 2026-10-01, and linking the wrong Jay Sweeney is worse than
 * no link. Add entries in the same shape as above, e.g.
 *   { name: "LinkedIn", url: "https://www.linkedin.com/in/<handle>/" },
 *   { name: "X", url: "https://x.com/<handle>" },
 *
 * @type {{ name: string, url: string }[]}
 */
export const FOUNDER_LINKS = [];
